'use strict'

import Gsap, { TweenLite } from 'gsap';
import CustomBodymovin from './bodyMovin';

let self;

export default self = {
    container: document.querySelector('.preload-box'),

    init : () => {
        const hasVisited = sessionStorage.getItem('hasVisited');
        TweenLite.to('.preload-cover', 1, {autoAlpha: 0});
        
        if (!hasVisited) {
            const preloaderTl = new TimelineMax();
            const logo = new CustomBodymovin({
              elm: document.getElementById('bodymovinLogo'),
              animationData: 'logo'
            })
    
            preloaderTl
                .set('.preload-box', {display: 'block'})
                .set('.preload-bg', {xPercent: '-100', autoAlpha: 1})
                .add( function(){ logo.play() } )
                .to('#bodymovinLogo', 0.01, {autoAlpha: 0}, '+=1.8')
                .to('.preload-bg', 0.6, {xPercent: 0}, '-=0.2')
                .to('.preload-bg', 0.6, {xPercent: '100'}, '+=0.2')
                .to('.preload-box', 1, {autoAlpha: 0}, '-=0.6')
                .from('.video-box h2', 0.6, {autoAlpha: 0, y: '50px', clearProps: 'all'});
            
            sessionStorage.setItem('hasVisited', true);
        }
    
    }
}
